import { toast, ToastOptions } from 'react-toastify';
import styles from '../sass/components/_toast.scss';
import { sample } from 'lodash';

const happyEmojis = [
  '😀',
  '😃',
  '😎',
  '🤩',
  '🤑',
  '👻',
  '👽',
  '🤘',
  '💪',
  '👏',
  '👍',
  '🕺🏻',
];
const questionableEmojis = ['🙄', '🧐', '🤔', '🤨'];
const unhappyEmojis = ['😥', '😫', '😓', '😔', '🤯', '😭', '😱', '😡', '🤕'];
const externalSuccessEmojis = ['✅'];
const externalErrorEmojis = ['❌'];

export enum TOAST_TYPES {
  ERROR = 'ERROR',
  EXTERNAL_ERROR = 'EXTERNAL_ERROR',
  SUCCESS = 'SUCCESS',
  EXTERNAL_SUCCESS = 'EXTERNAL_SUCCESS',
  WARNING = 'WARNING',
}

const toastConfig: ToastOptions = {
  position: 'top-right',
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const showToast = (message: string | Error, toastType?: TOAST_TYPES) => {
  switch (toastType) {
    case TOAST_TYPES.SUCCESS:
      toast.success(`${sample(happyEmojis)} ${message}`, {
        ...toastConfig,
        className: styles.successToast,
        progressClassName: styles.successProgress,
      });
      break;
    case TOAST_TYPES.EXTERNAL_SUCCESS:
      toast.success(`${sample(externalSuccessEmojis)} ${message}`, {
        ...toastConfig,
        className: styles.successToast,
        progressClassName: styles.successProgress,
      });
      break;
    case TOAST_TYPES.ERROR:
      toast.error(`${sample(unhappyEmojis)} ${message}`, {
        ...toastConfig,
        className: styles.errorToast,
        autoClose: false,
      });
      break;
    case TOAST_TYPES.EXTERNAL_ERROR:
      toast.error(`${sample(externalErrorEmojis)} ${message}`, {
        ...toastConfig,
        className: styles.errorToast,
        autoClose: false,
      });
      break;
    case TOAST_TYPES.WARNING:
      toast.warn(`${sample(questionableEmojis)} ${message}`, {
        ...toastConfig,
        className: styles.warningToast,
        autoClose: false,
      });
      break;
    default:
      toast(`${sample(happyEmojis)} ${message}`, {
        ...toastConfig,
        className: styles.toast,
        progressClassName: styles.normalProgress,
      });
      break;
  }
};
